import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';

const Magnet = ({
  children,
  padding = 50,
  disabled = false,
  magnetStrength = 0.3,
  activeTransition = { type: 'spring', stiffness: 200, damping: 15, mass: 0.1 },
  inactiveTransition = { type: 'spring', stiffness: 300, damping: 20 },
  className = '',
  ...props
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const ref = useRef(null);

  const handleMouseMove = (e) => {
    if (disabled || !ref.current) return;

    const { clientX, clientY } = e;
    const { height, width, left, top } = ref.current.getBoundingClientRect();
    const middleX = clientX - (left + width / 2);
    const middleY = clientY - (top + height / 2);

    setPosition({ x: middleX * magnetStrength, y: middleY * magnetStrength });
  };

  const handleMouseLeave = () => {
    setPosition({ x: 0, y: 0 });
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={{ x: position.x, y: position.y }}
      transition={position.x !== 0 || position.y !== 0 ? activeTransition : inactiveTransition}
      className={`magnet-wrapper ${className}`}
      style={{ display: 'inline-block' }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default Magnet;
